"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.limit = exports.currentTerm = exports.queryId = exports.body21 = exports.productCode = exports.imageName = exports.fontName = exports.version = exports.assetPath = exports.propertyName = exports.paragraphId = exports.familyName1 = exports.familyHiveId = exports.searchPreviewName = exports.body20 = exports.documentViewName = exports.subscriptionId = exports.body19 = exports.ticket = exports.email = exports.body18 = exports.markId = exports.changes = exports.secondMarkId = exports.firstMarkId = exports.fieldsetName = exports.subscriptionName = exports.body17 = exports.bookmark = exports.familyName = exports.direction = exports.relationTypeCodes = exports.targetBookmark = exports.sourceBookmark = exports.relationTypeCode = exports.fileName = exports.identifier = exports.fullName1 = exports.body16 = exports.properties = exports.partName = exports.fieldSetName = exports.assetCollectionId1 = exports.sectionIds = exports.sectionName = exports.variantType = exports.accept4 = exports.name = exports.variantTypeCode = exports.revisionNumber = exports.documentPath = exports.assetCollectionTemplateId = exports.artifactId = exports.body15 = exports.releaseNumber = exports.folderId = exports.body14 = exports.nodeId = exports.accept3 = exports.index = exports.sourceFolderId = exports.body13 = exports.accept2 = exports.file = exports.contentType1 = exports.body12 = exports.body11 = exports.documentRevisionNumber = exports.body10 = exports.documentRevision = exports.body9 = exports.documentRevisionId = exports.documentId = exports.body8 = exports.body7 = exports.portalId1 = exports.userId = exports.body6 = exports.body5 = exports.assetCollectionId = exports.permission = exports.count = exports.fullName = exports.hiveId = exports.accept1 = exports.body4 = exports.annotationId = exports.body3 = exports.body2 = exports.body1 = exports.targetId = exports.assetItemId = exports.contextId = exports.query = exports.body = exports.contentType = exports.portalId = exports.accept = exports.returnUrl = exports.$host = void 0;
exports.body25 = exports.take = exports.q = exports.lang = exports.body24 = exports.taxonomyName = exports.portalId2 = exports.body23 = exports.languageCode = exports.body22 = void 0;

var _mappers = require("../models/mappers");

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
var $host = {
  parameterPath: "$host",
  mapper: {
    serializedName: "$host",
    required: true,
    type: {
      name: "String"
    }
  },
  skipEncoding: true
};
exports.$host = $host;
var returnUrl = {
  parameterPath: ["options", "returnUrl"],
  mapper: {
    defaultValue: "/",
    serializedName: "returnUrl",
    type: {
      name: "String"
    }
  }
};
exports.returnUrl = returnUrl;
var accept = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/json, text/json",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
};
exports.accept = accept;
var portalId = {
  parameterPath: "portalId",
  mapper: {
    serializedName: "portalId",
    required: true,
    type: {
      name: "Uuid"
    }
  }
};
exports.portalId = portalId;
var contentType = {
  parameterPath: ["options", "contentType"],
  mapper: {
    defaultValue: "application/json-patch+json",
    isConstant: true,
    serializedName: "Content-Type",
    type: {
      name: "String"
    }
  }
};
exports.contentType = contentType;
var body = {
  parameterPath: ["options", "body"],
  mapper: _mappers.AiCompletionNamedConfigurationDto
};
exports.body = body;
var query = {
  parameterPath: "query",
  mapper: {
    serializedName: "query",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.query = query;
var contextId = {
  parameterPath: "contextId",
  mapper: {
    serializedName: "contextId",
    required: true,
    type: {
      name: "Uuid"
    }
  }
};
exports.contextId = contextId;
var assetItemId = {
  parameterPath: "assetItemId",
  mapper: {
    serializedName: "assetItemId",
    required: true,
    type: {
      name: "Uuid"
    }
  }
};
exports.assetItemId = assetItemId;
var targetId = {
  parameterPath: "targetId",
  mapper: {
    serializedName: "targetId",
    required: true,
    type: {
      name: "Uuid"
    }
  }
};
exports.targetId = targetId;
var body1 = {
  parameterPath: "body",
  mapper: _mappers.HtmlNewAnnotationDTO
};
exports.body1 = body1;
var body2 = {
  parameterPath: "body",
  mapper: _mappers.PdfNewAnnotationDTO
};
exports.body2 = body2;
var body3 = {
  parameterPath: "body",
  mapper: _mappers.HtmlAnnotationModel
};
exports.body3 = body3;
var annotationId = {
  parameterPath: "annotationId",
  mapper: {
    serializedName: "annotationId",
    required: true,
    type: {
      name: "Uuid"
    }
  }
};
exports.annotationId = annotationId;
var body4 = {
  parameterPath: "body",
  mapper: _mappers.PdfAnnotationModel
};
exports.body4 = body4;
var accept1 = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "text/plain, application/json, text/json",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
};
exports.accept1 = accept1;
var hiveId = {
  parameterPath: "hiveId",
  mapper: {
    serializedName: "hiveId",
    required: true,
    type: {
      name: "Uuid"
    }
  }
};
exports.hiveId = hiveId;
var fullName = {
  parameterPath: "fullName",
  mapper: {
    serializedName: "fullName",
    required: true,
    type: {
      name: "String"
    }
  },
  skipEncoding: true
};
exports.fullName = fullName;
var count = {
  parameterPath: ["options", "count"],
  mapper: {
    serializedName: "count",
    type: {
      name: "Number"
    }
  }
};
exports.count = count;
var permission = {
  parameterPath: ["options", "permission"],
  mapper: {
    serializedName: "permission",
    type: {
      name: "String"
    }
  }
};
exports.permission = permission;
var assetCollectionId = {
  parameterPath: "assetCollectionId",
  mapper: {
    serializedName: "assetCollectionId",
    required: true,
    type: {
      name: "Uuid"
    }
  }
};
exports.assetCollectionId = assetCollectionId;
var body5 = {
  parameterPath: "body",
  mapper: _mappers.AssetCollectionViewModel
};
exports.body5 = body5;
var body6 = {
  parameterPath: "body",
  mapper: _mappers.AddMembersRequest
};
exports.body6 = body6;
var userId = {
  parameterPath: "userId",
  mapper: {
    serializedName: "userId",
    required: true,
    type: {
      name: "Uuid"
    }
  }
};
exports.userId = userId;
var portalId1 = {
  parameterPath: "portalId",
  mapper: {
    serializedName: "portalId",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.portalId1 = portalId1;
var body7 = {
  parameterPath: "body",
  mapper: _mappers.CreateAssetCollectionRequest
};
exports.body7 = body7;
var body8 = {
  parameterPath: "body",
  mapper: {
    serializedName: "body",
    required: true,
    type: {
      name: "Sequence",
      element: {
        type: {
          name: "Composite",
          className: "AssetCollectionDocumentAdditionModel"
        }
      }
    }
  }
};
exports.body8 = body8;
var documentId = {
  parameterPath: "documentId",
  mapper: {
    serializedName: "documentId",
    required: true,
    type: {
      name: "Uuid"
    }
  }
};
exports.documentId = documentId;
var documentRevisionId = {
  parameterPath: "documentRevisionId",
  mapper: {
    serializedName: "documentRevisionId",
    required: true,
    type: {
      name: "Number"
    }
  }
};
exports.documentRevisionId = documentRevisionId;
var body9 = {
  parameterPath: "body",
  mapper: _mappers.CreateAssetCollectionFromQuoteRequest
};
exports.body9 = body9;
var documentRevision = {
  parameterPath: "documentRevision",
  mapper: {
    serializedName: "documentRevision",
    required: true,
    type: {
      name: "Number"
    }
  }
};
exports.documentRevision = documentRevision;
var body10 = {
  parameterPath: "body",
  mapper: _mappers.FlowQuoteModel
};
exports.body10 = body10;
var documentRevisionNumber = {
  parameterPath: "documentRevisionNumber",
  mapper: {
    serializedName: "documentRevisionNumber",
    required: true,
    type: {
      name: "Number"
    }
  }
};
exports.documentRevisionNumber = documentRevisionNumber;
var body11 = {
  parameterPath: "body",
  mapper: _mappers.GeometricSelectionModel
};
exports.body11 = body11;
var body12 = {
  parameterPath: "body",
  mapper: _mappers.CreateAssetCollectionFromPdfQuoteRequest
};
exports.body12 = body12;
var contentType1 = {
  parameterPath: ["options", "contentType"],
  mapper: {
    defaultValue: "multipart/form-data",
    isConstant: true,
    serializedName: "Content-Type",
    type: {
      name: "String"
    }
  }
};
exports.contentType1 = contentType1;
var file = {
  parameterPath: ["options", "file"],
  mapper: {
    serializedName: "file",
    type: {
      name: "Stream"
    }
  }
};
exports.file = file;
var accept2 = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/json, text/json",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
};
exports.accept2 = accept2;
var body13 = {
  parameterPath: "body",
  mapper: _mappers.AssetItemTargetLocation
};
exports.body13 = body13;
var sourceFolderId = {
  parameterPath: "sourceFolderId",
  mapper: {
    serializedName: "sourceFolderId",
    required: true,
    type: {
      name: "Uuid"
    }
  }
};
exports.sourceFolderId = sourceFolderId;
var index = {
  parameterPath: "index",
  mapper: {
    serializedName: "index",
    required: true,
    type: {
      name: "Number"
    }
  }
};
exports.index = index;
var accept3 = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/pdf",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
};
exports.accept3 = accept3;
var nodeId = {
  parameterPath: "nodeId",
  mapper: {
    serializedName: "nodeId",
    required: true,
    type: {
      name: "Uuid"
    }
  }
};
exports.nodeId = nodeId;
var body14 = {
  parameterPath: "body",
  mapper: _mappers.NodeInfo
};
exports.body14 = body14;
var folderId = {
  parameterPath: "folderId",
  mapper: {
    serializedName: "folderId",
    required: true,
    type: {
      name: "Uuid"
    }
  }
};
exports.folderId = folderId;
var releaseNumber = {
  parameterPath: "releaseNumber",
  mapper: {
    serializedName: "releaseNumber",
    required: true,
    type: {
      name: "Number"
    }
  }
};
exports.releaseNumber = releaseNumber;
var body15 = {
  parameterPath: "body",
  mapper: _mappers.AssetCollectionReleaseInfo
};
exports.body15 = body15;
var artifactId = {
  parameterPath: "artifactId",
  mapper: {
    serializedName: "artifactId",
    required: true,
    type: {
      name: "Uuid"
    }
  }
};
exports.artifactId = artifactId;
var assetCollectionTemplateId = {
  parameterPath: "assetCollectionTemplateId",
  mapper: {
    serializedName: "assetCollectionTemplateId",
    required: true,
    type: {
      name: "Uuid"
    }
  }
};
exports.assetCollectionTemplateId = assetCollectionTemplateId;
var documentPath = {
  parameterPath: "documentPath",
  mapper: {
    serializedName: "documentPath",
    required: true,
    type: {
      name: "String"
    }
  },
  skipEncoding: true
};
exports.documentPath = documentPath;
var revisionNumber = {
  parameterPath: "revisionNumber",
  mapper: {
    serializedName: "revisionNumber",
    required: true,
    type: {
      name: "Number"
    }
  }
};
exports.revisionNumber = revisionNumber;
var variantTypeCode = {
  parameterPath: "variantTypeCode",
  mapper: {
    serializedName: "variantTypeCode",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.variantTypeCode = variantTypeCode;
var name = {
  parameterPath: "name",
  mapper: {
    serializedName: "name",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.name = name;
var accept4 = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/octet-stream",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
};
exports.accept4 = accept4;
var variantType = {
  parameterPath: "variantType",
  mapper: {
    serializedName: "variantType",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.variantType = variantType;
var sectionName = {
  parameterPath: "sectionName",
  mapper: {
    serializedName: "sectionName",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.sectionName = sectionName;
var sectionIds = {
  parameterPath: "sectionIds",
  mapper: {
    serializedName: "sectionIds",
    required: true,
    type: {
      name: "Sequence",
      element: {
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.sectionIds = sectionIds;
var assetCollectionId1 = {
  parameterPath: ["options", "assetCollectionId"],
  mapper: {
    serializedName: "assetCollectionId",
    type: {
      name: "Uuid"
    }
  }
};
exports.assetCollectionId1 = assetCollectionId1;
var fieldSetName = {
  parameterPath: "fieldSetName",
  mapper: {
    serializedName: "fieldSetName",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.fieldSetName = fieldSetName;
var partName = {
  parameterPath: ["options", "partName"],
  mapper: {
    serializedName: "partName",
    type: {
      name: "String"
    }
  }
};
exports.partName = partName;
var properties = {
  parameterPath: ["options", "properties"],
  mapper: {
    serializedName: "properties",
    type: {
      name: "Sequence",
      element: {
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.properties = properties;
var body16 = {
  parameterPath: "body",
  mapper: _mappers.PrintRequestModel
};
exports.body16 = body16;
var fullName1 = {
  parameterPath: "fullName",
  mapper: {
    serializedName: "fullName",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.fullName1 = fullName1;
var identifier = {
  parameterPath: ["options", "identifier"],
  mapper: {
    serializedName: "identifier",
    type: {
      name: "String"
    }
  }
};
exports.identifier = identifier;
var fileName = {
  parameterPath: ["options", "fileName"],
  mapper: {
    serializedName: "fileName",
    type: {
      name: "String"
    }
  }
};
exports.fileName = fileName;
var relationTypeCode = {
  parameterPath: "relationTypeCode",
  mapper: {
    serializedName: "relationTypeCode",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.relationTypeCode = relationTypeCode;
var sourceBookmark = {
  parameterPath: "sourceBookmark",
  mapper: {
    serializedName: "sourceBookmark",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.sourceBookmark = sourceBookmark;
var targetBookmark = {
  parameterPath: "targetBookmark",
  mapper: {
    serializedName: "targetBookmark",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.targetBookmark = targetBookmark;
var relationTypeCodes = {
  parameterPath: "relationTypeCodes",
  mapper: {
    serializedName: "relationTypeCodes",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.relationTypeCodes = relationTypeCodes;
var direction = {
  parameterPath: "direction",
  mapper: {
    defaultValue: "forward",
    serializedName: "direction",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.direction = direction;
var familyName = {
  parameterPath: "familyName",
  mapper: {
    serializedName: "familyName",
    required: true,
    type: {
      name: "String"
    }
  },
  skipEncoding: true
};
exports.familyName = familyName;
var bookmark = {
  parameterPath: ["options", "bookmark"],
  mapper: {
    serializedName: "bookmark",
    type: {
      name: "String"
    }
  }
};
exports.bookmark = bookmark;
var body17 = {
  parameterPath: "body",
  mapper: {
    serializedName: "body",
    required: true,
    type: {
      name: "any"
    }
  }
};
exports.body17 = body17;
var subscriptionName = {
  parameterPath: "subscriptionName",
  mapper: {
    serializedName: "subscriptionName",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.subscriptionName = subscriptionName;
var fieldsetName = {
  parameterPath: "fieldsetName",
  mapper: {
    serializedName: "fieldsetName",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.fieldsetName = fieldsetName;
var firstMarkId = {
  parameterPath: ["options", "firstMarkId"],
  mapper: {
    serializedName: "firstMarkId",
    type: {
      name: "Uuid"
    }
  }
};
exports.firstMarkId = firstMarkId;
var secondMarkId = {
  parameterPath: ["options", "secondMarkId"],
  mapper: {
    serializedName: "secondMarkId",
    type: {
      name: "Uuid"
    }
  }
};
exports.secondMarkId = secondMarkId;
var changes = {
  parameterPath: ["options", "changes"],
  mapper: {
    defaultValue: "",
    serializedName: "changes",
    type: {
      name: "Enum",
      allowedValues: [0, 1, 2, 3, 4]
    }
  }
};
exports.changes = changes;
var markId = {
  parameterPath: "markId",
  mapper: {
    serializedName: "markId",
    required: true,
    type: {
      name: "Uuid"
    }
  }
};
exports.markId = markId;
var body18 = {
  parameterPath: "body",
  mapper: _mappers.CreateOrUpdateDocumentVersionSubscriptionModel
};
exports.body18 = body18;
var email = {
  parameterPath: "email",
  mapper: {
    serializedName: "email",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.email = email;
var ticket = {
  parameterPath: ["options", "ticket"],
  mapper: {
    serializedName: "ticket",
    type: {
      name: "String"
    }
  }
};
exports.ticket = ticket;
var body19 = {
  parameterPath: "body",
  mapper: _mappers.DocumentVersionSubscriptionInfo
};
exports.body19 = body19;
var subscriptionId = {
  parameterPath: "subscriptionId",
  mapper: {
    serializedName: "subscriptionId",
    required: true,
    type: {
      name: "Uuid"
    }
  }
};
exports.subscriptionId = subscriptionId;
var documentViewName = {
  parameterPath: "documentViewName",
  mapper: {
    serializedName: "documentViewName",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.documentViewName = documentViewName;
var body20 = {
  parameterPath: "body",
  mapper: _mappers.DocumentLinkInfo
};
exports.body20 = body20;
var searchPreviewName = {
  parameterPath: ["options", "searchPreviewName"],
  mapper: {
    serializedName: "searchPreviewName",
    type: {
      name: "String"
    }
  }
};
exports.searchPreviewName = searchPreviewName;
var familyHiveId = {
  parameterPath: "familyHiveId",
  mapper: {
    serializedName: "familyHiveId",
    required: true,
    type: {
      name: "Uuid"
    }
  }
};
exports.familyHiveId = familyHiveId;
var familyName1 = {
  parameterPath: "familyName",
  mapper: {
    serializedName: "familyName",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.familyName1 = familyName1;
var paragraphId = {
  parameterPath: "paragraphId",
  mapper: {
    serializedName: "paragraphId",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.paragraphId = paragraphId;
var propertyName = {
  parameterPath: "propertyName",
  mapper: {
    serializedName: "propertyName",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.propertyName = propertyName;
var assetPath = {
  parameterPath: "assetPath",
  mapper: {
    serializedName: "assetPath",
    required: true,
    type: {
      name: "String"
    }
  },
  skipEncoding: true
};
exports.assetPath = assetPath;
var version = {
  parameterPath: ["options", "version"],
  mapper: {
    serializedName: "version",
    type: {
      name: "String"
    }
  }
};
exports.version = version;
var fontName = {
  parameterPath: "fontName",
  mapper: {
    serializedName: "fontName",
    required: true,
    type: {
      name: "String"
    }
  },
  skipEncoding: true
};
exports.fontName = fontName;
var imageName = {
  parameterPath: "imageName",
  mapper: {
    serializedName: "imageName",
    required: true,
    type: {
      name: "String"
    }
  },
  skipEncoding: true
};
exports.imageName = imageName;
var productCode = {
  parameterPath: "productCode",
  mapper: {
    serializedName: "productCode",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.productCode = productCode;
var body21 = {
  parameterPath: "body",
  mapper: _mappers.SavedSearchQueryViewModel
};
exports.body21 = body21;
var queryId = {
  parameterPath: "queryId",
  mapper: {
    serializedName: "queryId",
    required: true,
    type: {
      name: "Uuid"
    }
  }
};
exports.queryId = queryId;
var currentTerm = {
  parameterPath: ["options", "currentTerm"],
  mapper: {
    serializedName: "currentTerm",
    type: {
      name: "String"
    }
  }
};
exports.currentTerm = currentTerm;
var limit = {
  parameterPath: ["options", "limit"],
  mapper: {
    defaultValue: 10,
    serializedName: "limit",
    type: {
      name: "Number"
    }
  }
};
exports.limit = limit;
var body22 = {
  parameterPath: "body",
  mapper: _mappers.SearchResultsExportInfo
};
exports.body22 = body22;
var languageCode = {
  parameterPath: ["options", "languageCode"],
  mapper: {
    serializedName: "languageCode",
    type: {
      name: "String"
    }
  }
};
exports.languageCode = languageCode;
var body23 = {
  parameterPath: "body",
  mapper: _mappers.SearchSubscriptionInfo
};
exports.body23 = body23;
var portalId2 = {
  parameterPath: ["options", "portalId"],
  mapper: {
    serializedName: "portalId",
    type: {
      name: "Uuid"
    }
  }
};
exports.portalId2 = portalId2;
var taxonomyName = {
  parameterPath: "taxonomyName",
  mapper: {
    serializedName: "taxonomyName",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.taxonomyName = taxonomyName;
var body24 = {
  parameterPath: "body",
  mapper: _mappers.TicketInfo
};
exports.body24 = body24;
var lang = {
  parameterPath: "lang",
  mapper: {
    serializedName: "lang",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.lang = lang;
var q = {
  parameterPath: ["options", "q"],
  mapper: {
    serializedName: "q",
    type: {
      name: "String"
    }
  }
};
exports.q = q;
var take = {
  parameterPath: ["options", "take"],
  mapper: {
    serializedName: "take",
    type: {
      name: "Number"
    }
  }
};
exports.take = take;
var body25 = {
  parameterPath: "body",
  mapper: {
    serializedName: "body",
    required: true,
    type: {
      name: "String"
    }
  }
};
exports.body25 = body25;